import { nextTick, ref } from 'vue'

type TooltipExpose = {
  open?: (target: HTMLElement, content: string) => void | Promise<unknown>
  hide?: () => void | Promise<unknown>
  /** @deprecated 优先使用 open(target, content) */
  onOpen?: (event?: Event) => void
}

export function useOverflowTooltip(
  getTooltip?: () => TooltipExpose | undefined,
  getContent?: () => string
) {
  const overflowActive = ref(false)

  function applyOverflow(el: HTMLElement | null | undefined) {
    const overflow = !!el && el.scrollWidth > el.clientWidth
    overflowActive.value = overflow
    return overflow
  }

  async function onTextMouseEnter(event: MouseEvent) {
    const el = event.currentTarget as HTMLElement
    const overflow = applyOverflow(el)
    if (!overflow) {
      return
    }
    await nextTick()
    const tooltip = getTooltip?.()
    const content = getContent?.() ?? el.textContent ?? ''
    if (tooltip?.open) {
      await tooltip.open(el, content)
      return
    }
    tooltip?.onOpen?.(event)
  }

  function onTextMouseLeave() {
    const tooltip = getTooltip?.()
    if (tooltip?.hide) {
      void tooltip.hide()
    }
    overflowActive.value = false
  }

  function onTooltipHide() {
    overflowActive.value = false
  }

  return {
    overflowActive,
    applyOverflow,
    onTextMouseEnter,
    onTextMouseLeave,
    onTooltipHide,
  }
}
